import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { trackEvent } from '@/analytics';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { AnalyticsEvents } from '@/constants/analytics';
import { routeMap } from '@/routes/routeMap';
import Button from '@/ui-kit/components/Button/Button';

export type OpenBankingRecoveryCancellationModalPayload = {
  applicationId: string;
};

type Props = ModalProps<OpenBankingRecoveryCancellationModalPayload>;

const OpenBankingRecoveryCancellation = ({ closeModal, payload: { applicationId } }: Props) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'OpenBankingRecoveryCancellation' });
  const navigate = useNavigate();

  const handleConfirmCancel = () => {
    trackEvent(AnalyticsEvents.SE.OPEN_BANKING_RECOVERY_DECLINE, { applicationId });
    closeModal();
    void navigate(routeMap.application.root, { replace: true });
  };

  return (
    <Modal title={t('title')}>
      <div className="flex flex-col gap-4">
        <p>{t('description1')}</p>
        <p>{t('description2')}</p>
      </div>
      <ModalActions>
        <Button onClick={handleConfirmCancel}>{t('confirmButton')}</Button>
        <Button variant="secondary" onClick={closeModal}>
          {t('goBackButton')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default OpenBankingRecoveryCancellation;
